import api from '@/api'
import DateService from '@/helpers/DateServiceOld'
import Vue from 'vue'
import socket from '@/plugins/socket'
import { MEDIO_CATEGORIA } from '@/helpers/constants'

const Q = require('q')

const state = {
  medios: [],
  tiposMedio: [],
  bases: [],
  zonas: [],
  emergencias: [],
  comunidades_autonomas: [],
  servicios: [],
  dispositivosHermes: []
}

const getters = {
  medios: (state) => {
    // console.log('MEDIOS', state.medios.filter(x => x.MEDIO === '113'))
    return state.medios
  },
  getMedioByID: (state) => (idMedio) => {
    let medio = null

    if (idMedio) {
      medio = state.medios.find(x => x.ID_MEDIO.equalsIgnoreCase(idMedio))
    }
    return medio
  },

  tiposMedio: (state) => state.tiposMedio,

  tiposMedioAereo: (state) => {
    return state.tiposMedio.filter(x => x.CATEGORIA.ID_MEDIO_CATEGORIA.equalsIgnoreCase(MEDIO_CATEGORIA.AEREO))
  },

  bases: (state) => state.bases,

  zonas: (state) => state.zonas,

  emergencias: (state) => state.emergencias,

  comunidades_autonomas: (state) => state.comunidades_autonomas,

  servicios: (state) => state.servicios,

  dispositivosHermes: (state) => state.dispositivosHermes
}

const mutations = {
  SET_MEDIOS(state, medios) {
    state.medios = medios
  },

  SET_TIPOS_MEDIO(state, tiposMedio) {
    state.tiposMedio = tiposMedio
  },
  SET_BASES(state, bases) {
    state.bases = bases
  },
  SET_ZONAS_MEDIO(state, zonas) {
    state.zonas = zonas
  },

  SET_EMERGENCIAS(state, emergencias) {
    state.emergencias = emergencias
  },

  SET_COMUNIDADES_AUTONOMAS(state, comunidadesAutonomas) {
    state.comunidades_autonomas = comunidadesAutonomas
  },

  SET_SERVICIOS(state, servicios) {
    state.servicios = servicios
  },

  SET_DISPOSITIVOS_HERMES(state, dispositivos) {
    state.dispositivosHermes = dispositivos
  },

  SOCKET_updatePositionMedio(state, data) {
    if (data) {
      for (let i = 0; i < state.medios.length; i++) {
        const medio = state.medios[i]

        const positionDispositivo = medio.MEDIO_DISPOSITIVOS.findIndex(x => x.ID_GEO_DISPOSITIVO.equalsIgnoreCase(data.ID_GEO_DISPOSITIVO))
        if (positionDispositivo > -1) {
          const dispositivo = medio.MEDIO_DISPOSITIVOS[positionDispositivo]

          dispositivo.LATITUD = data.LATITUD
          dispositivo.LONGITUD = data.LONGITUD
          dispositivo.ALTITUD = data.ALTITUD
          dispositivo.BATERIA = data.BATERIA
          dispositivo.FECHA = data.FECHA

          // Actualizar ULT_POSICION
          if (DateService.parseDate(dispositivo.FECHA) > DateService.parseDate(medio.ULT_POSICION.FECHA)) {
            medio.ULT_POSICION = dispositivo
          }

          Vue.set(state.medios, i, medio)
        }
      }
    }
  },
  SOCKET_addMedio(state, data) {
    state.medios.push(data)
    this.notify('Nuevo medio', `Se ha añadido el medio ${data.MEDIO}`)
  },
  SOCKET_updateMedio(state, data) {
    const positionMedio = state.medios.findIndex(x => x.ID_MEDIO.equalsIgnoreCase(data.ID_MEDIO))

    if (positionMedio !== -1) {
      state.medios[positionMedio] = data
      this.notify('Medio actualizado', `Se ha actualizado el medio ${data.MEDIO}`)
    }
    Vue.set(state.medios, positionMedio, data)
  },
  SOCKET_deleteMedio(state, data) {
    const positionMedio = state.medios.findIndex(x => x.ID_MEDIO.equalsIgnoreCase(data.ID_MEDIO))

    if (positionMedio !== -1) {
      state.medios.splice(positionMedio, 1)
      this.notify('Medio borrado', `Se ha borrado el medio ${data.MEDIO}`)
    }
  },
  SOCKET_emergenciaMedio(state, data) {
    const positionMedio = state.medios.findIndex(x => x.ID_MEDIO.equalsIgnoreCase(data.ID_MEDIO))

    if (positionMedio !== -1) {
      const medio = state.medios[positionMedio]

      medio.EN_EMERGENCIA = data.IS_EMERGENCIA
      // TODO: Vue.set(state.medios, positionMedio, medio)

      if (data.IS_EMERGENCIA) {
        const emergencia = { ID_MEDIO: data.ID_MEDIO, LATITUD: data.LATITUD, LONGITUD: data.LONGITUD, FECHA_INICIO: data.FECHA, FECHA_FIN: null }
        state.emergencias.push(emergencia)
      } else {
        const indexEmergencia = state.emergencias.findIndex(x => x.ID_MEDIO === state.ID_MEDIO)
        state.emergencias.splice(indexEmergencia, 1)
      }

      const title = data.IS_EMERGENCIA ? 'EMERGENCIA' : 'Emergencia finalizada'
      const msg = data.IS_EMERGENCIA ? `El medio ${medio.MEDIO} ha notificado una emergencia` : `La emergencia del medio ${medio.MEDIO} ha sido finalizada`
      this.notify(title, msg, data.IS_EMERGENCIA ? 'error' : 'success')
    }
  }
}

const actions = {
  async fetchMedios({ commit }) {
    const deferred = Q.defer()

    try {
      const response = await api.medio.getMedios()
      // console.log('MEDIOS', response.data.filter(x => x.MEDIO === '113'))
      commit('SET_MEDIOS', response.data)

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },
  async fetchTiposMedio({ commit }) {
    const deferred = Q.defer()

    try {
      const response = await api.medio.getTiposMedio()
      commit('SET_TIPOS_MEDIO', response.data)

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },
  async fetchBases({ commit }) {
    const deferred = Q.defer()

    try {
      const response = await api.medio.getBases()
      commit('SET_BASES', response.data)

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },
  async fetchZonasMedio({ commit }) {
    const deferred = Q.defer()

    try {
      const response = await api.medio.getZonasMedio()
      commit('SET_ZONAS_MEDIO', response.data)

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },

  async fetchDispositivosHermes({ commit }) {
    try {
      const request = await api.medio.getDispositivosHermes()
      commit('SET_DISPOSITIVOS_HERMES', request.data)
    } catch (error) {
      console.error('Error al obtener dispositivosHermes', error)
      throw error
    }
  },

  async addMedio({ commit }, data) {
    const deferred = Q.defer()

    try {
      const response = await api.medio.addMedio(data)

      if (response.status === 200) {
        commit('SOCKET_addMedio', data)
        socket.emit('addMedio', data)
      }

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },
  async updateMedio({ commit }, data) {
    const deferred = Q.defer()

    try {
      const response = await api.medio.updateMedio(data)

      if (response.status === 200) {
        commit('SOCKET_updateMedio', data)
        socket.emit('updateMedio', data)
      }

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },
  async deleteMedio({ commit }, data) {
    const deferred = Q.defer()

    try {
      const response = await api.medio.deleteMedio(data)

      if (response.status === 200) {
        commit('SOCKET_deleteMedio', data)
        socket.emit('deleteMedio', data)
      }

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },

  async fetchEmergencias({ commit }) {
    const deferred = Q.defer()

    try {
      const response = await api.medio.getEmergencias()
      commit('SET_EMERGENCIAS', response.data)

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },

  async fetchComunidadesAutonomas({ commit }) {
    try {
      const response = await api.medio.getComunidadesAutonomas()
      commit('SET_COMUNIDADES_AUTONOMAS', response.data)
    } catch (err) {
      console.error('Error al obtener comunidades autónomas', err)
      throw err
    }
  },

  async fetchServicios({ commit }) {
    try {
      const response = await api.medio.getServicios()
      commit('SET_SERVICIOS', response.data)
    } catch (err) {
      console.error('Error al obtener servicios', err)
      throw err
    }
  },

  async setEmergenciaMedio({ commit }, data) { // TODO: testear
    const deferred = Q.defer()

    try {
      const response = await api.medio.setEmergenciaMedio(data)

      if (response.status === 200) {
        commit('SOCKET_emergenciaMedio', data)
        socket.emit('emergenciaMedio', data)
      }

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
